import { API, loadAuthToken } from "./api";

export const WORK_STATUSES = ["Pending", "Working", "Need Documents", "OTP Required", "Submitted", "Completed", "Rejected", "Cancelled"];
export const OPEN_STATUSES = ["Pending", "Working", "Need Documents", "OTP Required", "Submitted"];
export const STATUS_TONE = {
  Pending: "bg-slate-100 text-slate-700", Working: "bg-blue-100 text-blue-800", "Need Documents": "bg-amber-100 text-amber-800",
  "OTP Required": "bg-purple-100 text-purple-800", Submitted: "bg-teal-100 text-teal-800", Completed: "bg-green-100 text-green-800",
  Rejected: "bg-red-100 text-red-700", Cancelled: "bg-slate-200 text-slate-600",
};
export const WORK_FILE_KINDS = ["Application Receipt", "Payment Receipt", "Acknowledgement Slip", "Final Application PDF", "Admit Card", "Final Certificate", "Additional Supporting File"];
export const DOC_GROUPS = {
  "Personal Documents": ["Customer Photo", "Signature", "Aadhaar (Masked)", "PAN Card", "Voter ID"],
  "Educational Documents": ["10th Marksheet", "10th Certificate", "12th Marksheet", "12th Certificate", "Graduation Marksheet", "Graduation Certificate", "Registration Card", "Admit Card", "Bonafide Certificate", "Admission Receipt"],
  "Government Certificates": ["Caste Certificate", "Residence Certificate", "Income Certificate", "OBC-NCL Certificate", "EWS Certificate", "Birth Certificate", "Disability Certificate"],
  "Other Documents": ["Scholarship Documents", "Passport-related Documents"],
};

export const me = () => { try { return JSON.parse(localStorage.getItem("ap_admin_user") || "{}"); } catch { return {}; } };
export const isAdmin = () => me().role === "super_admin";
export const isBranch = () => me().role === "branch_operator";

const tk = () => encodeURIComponent(loadAuthToken() || "");
export const photoUrl = (c) => (c?.photo_file ? `${API}/customers/${c.id}/photo?auth=${tk()}&v=${c.photo_file.file_id || c.photo_file.id}` : null);
export const docUrl = (cid, did, download) => `${API}/customers/${cid}/documents/${did}/file?auth=${tk()}${download ? "&download=true" : ""}`;
export const workFileUrl = (cid, wid, fid, download) => `${API}/customers/${cid}/works/${wid}/files/${fid}?auth=${tk()}${download ? "&download=true" : ""}`;

export const fmtDate = (v, withTime) => {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d)) return v;
  return withTime ? d.toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : d.toLocaleDateString("en-IN", { dateStyle: "medium" });
};
export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};
export const fromLocalInput = (v) => (v ? new Date(v).toISOString() : null);
export const rupee = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

export const waLink = (c) => {
  let m = (c.mobile || "").replace(/[^0-9]/g, "");
  if (m.length === 10) m = "91" + m;
  if (m.length < 11) return null;
  const msg = `नमस्ते ${c.name} जी 🙏\n${c.enquiry_subject ? `आपकी ${c.enquiry_subject} की पूछताछ के संबंध में ` : ""}Ashish Point की ओर से संदेश।\n— Ashish Point`;
  return `https://wa.me/${m}?text=${encodeURIComponent(msg)}`;
};
